import { render, staticRenderFns } from "./PaletteColor.vue?vue&type=template&id=18b5fd24&scoped=true"
import script from "./PaletteColor.vue?vue&type=script&lang=js"
export * from "./PaletteColor.vue?vue&type=script&lang=js"
import style0 from "./PaletteColor.vue?vue&type=style&index=0&id=18b5fd24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5fd24",
  null
  
)

export default component.exports